/* globals console, module, require */
/* jshint esversion: 6 */
/* jshint globalstrict: true */
'use strict';

module.exports = function (phone) {
    let a;
    if (typeof phone === 'string' && phone.length) {
        a = phone.split('x');
        a[0] = a[0].replace(/\D/g, '');
        switch (a[0].length) {
            case 11:
                break;
            case 10:
                a[0] = '1' + a[0];
                break;
            default:
                a[0] = ('00000000000' + a[0]).substr(-11);
                break;
        }
        return a.join('x');
    } else {
        return phone;
    }
};
